import { GAME_ID, REDUX_ACTIONS } from '../data/constants';

const initialState = {
  assignment: null,
  content: null,
  fluencyVisited: false,
  fluencySuppressionArmed: false,
};

const boostFluencyReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_PASSAGE_CONTENT:
      return { ...state, content: payload };

    case REDUX_ACTIONS.CLEAR_FLUENCY_ASSIGNMENT:
      return initialState;

    case REDUX_ACTIONS.SET_FLUENCY_ASSIGNMENT:
      return { ...state, assignment: payload };

    case REDUX_ACTIONS.SET_FLUENCY_VISITED:
      return { ...state, fluencyVisited: true };

    case REDUX_ACTIONS.SET_FLUENCY_SUPPRESSION_ARMED:
      return { ...state, fluencySuppressionArmed: payload };

    default:
      return state;
  }
};

export default boostFluencyReducer;
